
import React, { useState } from 'react';
import { Layout, Typography, Form, Input, Button, Alert, Spin } from 'antd';
import { UserOutlined, LockOutlined, IdcardOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import './SuperadminRegister.css';

const { Content, Header } = Layout;
const { Title, Text } = Typography;

const SuperadminRegister = () => {
  const [form] = Form.useForm();
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const response = await fetch('/backend/superadmin_register.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          email: values.email,
          password: values.password,
        }),
      });

      const result = await response.json();

      if (response.ok) {
        setSuccess('Inscription réussie ! Vous serez redirigé vers la page de connexion.');
        setError(null);
        form.resetFields();
        setTimeout(() => navigate('/superadminlogin'), 2000);
      } else {
        setError(result.error || 'Erreur lors de l\'inscription.');
        setSuccess(null);
      }
    } catch (error) {
      setError('Une erreur s\'est produite lors de l\'inscription.');
      setSuccess(null);
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <Layout className="auth-layout">
      <Header className="auth-header">
        <div className="logo">
          <IdcardOutlined className="logo-icon" />
          <Title level={4} className="logo-text">
            NH Guide - Superadmin
          </Title>
        </div>
      </Header>
      <Content className="auth-content">
        <div className="auth-container">
          <Title level={2} className="auth-title">
            Inscription Superadmin
          </Title>
          <Text className="auth-subtitle">
            Créez un compte superadmin pour gérer NH Guide.
          </Text>
          {error && (
            <Alert
              message={error}
              type="error"
              showIcon
              className="auth-alert auth-alert-error"
            />
          )}
          {success && (
            <Alert
              message={success}
              type="success"
              showIcon
              className="auth-alert auth-alert-success"
            />
          )}
          <Form
            form={form}
            name="superadminRegister"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            layout="vertical"
            className="auth-form"
          >
            <Form.Item
              label="Email"
              name="email"
              rules={[
                { required: true, message: 'Veuillez entrer votre email !' },
                { type: 'email', message: 'Veuillez entrer un email valide !' },
              ]}
            >
              <Input
                prefix={<UserOutlined className="input-icon" />}
                placeholder="superadmin@example.com"
                size="large"
                className="auth-input"
              />
            </Form.Item>
            <Form.Item
              label="Mot de passe"
              name="password"
              rules={[
                { required: true, message: 'Veuillez entrer votre mot de passe !' },
                { min: 6, message: 'Le mot de passe doit contenir au moins 6 caractères !' },
              ]}
            >
              <Input.Password
                prefix={<LockOutlined className="input-icon" />}
                placeholder="Mot de passe"
                size="large"
                className="auth-input"
              />
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                size="large"
                block
                className="auth-button"
                disabled={loading}
              >
                {loading ? <Spin size="small" /> : 'S\'inscrire'}
              </Button>
            </Form.Item>
            <Text className="auth-link-text">
              Déjà un compte ?{' '}
              <a onClick={() => navigate('/superadminlogin')} className="auth-link">
                Se connecter
              </a>
            </Text>
          </Form>
        </div>
      </Content>
    </Layout>
  );
};

export default SuperadminRegister;